import { service } from "@ember/service";
import { CATEGORY_STYLE_TYPES } from "discourse/lib/constants";
import { iconHTML } from "discourse/lib/icon-library";
import dReplaceEmoji from "discourse/ui-kit/helpers/d-replace-emoji";
import HashtagTypeBase from "./base";

export default class CategoryHashtagType extends HashtagTypeBase {
  @service site;

  get type() {
    return "category";
  }

  get preloadedData() {
    return this.site.categories || [];
  }

  generatePreloadedCssClasses() {
    return [
      // Set a default color for category hashtags. This is added here instead
      // of `hashtag.scss` because of the CSS precedence rules (<link> has a
      // higher precedence than <style>)
      ".hashtag-category-square { background-color: var(--primary-medium); }",
      ...super.generatePreloadedCssClasses(),
    ];
  }

  generateColorCssClasses(categoryOrHashtag) {
    let color, parentColor;
    if (categoryOrHashtag.colors) {
      if (categoryOrHashtag.colors.length === 1) {
        color = categoryOrHashtag.colors[0];
      } else {
        parentColor = categoryOrHashtag.colors[0];
        color = categoryOrHashtag.colors[1];
      }
    } else {
      color = categoryOrHashtag.color;
      if (
        categoryOrHashtag.parentCategory &&
        categoryOrHashtag.styleType === "square"
      ) {
        parentColor = categoryOrHashtag.parentCategory.color;
      }
    }

    let style;
    if (categoryOrHashtag.style_type === "square") {
      if (parentColor) {
        style = `background: linear-gradient(-90deg, #${color} 50%, #${parentColor} 50%);`;
      } else {
        style = `background-color: #${color};`;
      }
    } else if (categoryOrHashtag.style_type === "icon") {
      style = `color: #${color};`;
    } else {
      return [];
    }

    return [`.hashtag-color--category-${categoryOrHashtag.id} { ${style} }`];
  }

  generateIconHTML(hashtag) {
    const categoryId = Number(hashtag.id);
    const styleType = Object.hasOwn(CATEGORY_STYLE_TYPES, hashtag.style_type)
      ? hashtag.style_type
      : "square";

    if (!Number.isSafeInteger(categoryId) || categoryId <= 0) {
      return '<span class="hashtag-category-square"></span>';
    }

    const normalizedHashtag = {
      ...hashtag,
      id: categoryId,
      style_type: styleType,
    };
    normalizedHashtag.preloaded
      ? this.onLoad(normalizedHashtag)
      : this.load(categoryId);
    let style = "";

    if (styleType === "icon" && normalizedHashtag.icon) {
      style = iconHTML(normalizedHashtag.icon);
    }
    if (styleType === "emoji" && normalizedHashtag.emoji) {
      style = dReplaceEmoji(`:${normalizedHashtag.emoji}:`);
    }

    const colorCssClass = `hashtag-color--${this.type}-${categoryId}`;
    return `<span class="hashtag-category-${styleType} ${colorCssClass}">${style}</span>`;
  }

  isLoaded(id) {
    return !this.site.lazy_load_categories || super.isLoaded(id);
  }
}
